import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { BffCartAddress } from '@/core/models/bff-shopping-carts';
import { putBffShoppingCartShippingAddress } from '@/core/services/fetchers';

export const MUTATION_KEY = ['bff-update-cart-shipping-address'];

type Variables = {
  address: BffCartAddress;
};

async function mutationFn(params: {
  cartId: string;
  languageCode: string;
  address: BffCartAddress;
}): Promise<void> {
  await putBffShoppingCartShippingAddress({
    cartId: params.cartId,
    languageCode: params.languageCode,
    address: params.address,
  });
}

const useBffUpdateCartShippingAddressMutation = (
  {
    cartId,
    languageCode,
  }: {
    cartId: string | null;
    languageCode: string;
  },
  options?: Omit<
    UseMutationOptions<void, Error, Variables>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation({
    ...options,
    mutationKey: [...MUTATION_KEY, cartId, languageCode],
    mutationFn: (variables: Variables) => {
      if (!cartId) {
        throw new Error('Invalid cart ID');
      }
      return mutationFn({
        cartId,
        languageCode,
        address: variables.address,
      });
    },
  });

export default useBffUpdateCartShippingAddressMutation;
